












import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { ROUTE_NAMES } from "@/router/routenames";

import AppBar from "@/components/core/AppBar.vue";
import AppNavDrawer from "@/components/core/AppNavDrawer.vue";

@Component({
  components: {
    AppBar,
    AppNavDrawer
  }
})
export default class App extends Vue {
  dashboardRouteName = ROUTE_NAMES.DASHBOARD;
  homeRouteName = ROUTE_NAMES.HOME;
}
